import React, { useEffect } from "react";
import { AnimatePresence, Variants, motion } from "framer-motion";
import Backdrop from "./Backdrop";
import { useSelector } from "react-redux";
import { modalSelector } from "state/modalSlice";
import MintModal from "./MintModal";
import { StyledModalContent } from "./styled";

const dropIn: Variants = {
  hidden: {
    y: "-100vh",
  },
  visible: {
    y: 0,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: "100vh",
  },
};

const newspaper = {
  hidden: {
    transform: "scale(0)  rotateX(720deg)",
    opacity: 0,
    transition: {
      delay: 0.3,
    },
  },
  visible: {
    transform: "scale(1)  rotateX(0deg)",
    opacity: 1,
    transition: {
      duration: 0.5,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    transform: "scale(0)  rotateX(-360deg)",
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const badSuspension = {
  hidden: {
    y: "-100vh",
    opacity: 0,
    transform: "scale(0) rotateX(-360deg)",
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 0.2,
      type: "spring",
      damping: 15,
      stiffness: 500,
    },
  },
  exit: {
    y: "-100vh",
    opacity: 0,
  },
};

const Modal = () => {
  const { isModalOpen } = useSelector(modalSelector);
  const stopModalClose = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    e.stopPropagation();
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isModalOpen]);
  return (
    <AnimatePresence
      initial={false}
      exitBeforeEnter={true}
      onExitComplete={() => null}
    >
      {isModalOpen && (
        <Backdrop>
          <StyledModalContent
            as={motion.div}
            variants={newspaper}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={stopModalClose}
          >
            <MintModal />
          </StyledModalContent>
        </Backdrop>
      )}
    </AnimatePresence>
  );
};

export default React.memo(Modal);
